import {
  AfterViewInit,
  Directive,
  ElementRef,
  inject,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

@Directive({ selector: '[pxwScrollIntoView]', standalone: true })
export class ScrollIntoViewDirective implements AfterViewInit, OnChanges {
  rootEl = inject(ElementRef<HTMLElement>);

  @Input('pxwScrollIntoView') pxwScrollIntoView: unknown;

  ngAfterViewInit(): void {
    this.rootEl.nativeElement.scrollIntoView({ behavior: 'smooth' });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['pxwScrollIntoView']?.previousValue !== changes['pxwScrollIntoView']?.currentValue
    ) {
      this.rootEl.nativeElement.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
